import { useState, type FormEvent } from "react";
import { ApiError } from "../lib/api.ts";
import { useAuth } from "../lib/auth.tsx";
import { SURFACE_NAMES, surface } from "../lib/surface.ts";

export function SignIn() {
  const { signIn } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [problem, setProblem] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setProblem(null);
    setBusy(true);
    try {
      await signIn(email, password);
    } catch (error) {
      setProblem(error instanceof ApiError ? error.message : "Could not sign in.");
      setBusy(false);
    }
  }

  return (
    <div className="signin">
      <form className="card signin-card" onSubmit={submit}>
        <div className="card-body stack">
          <div className="stack-sm">
            <div className="signin-mark" aria-hidden="true" />
            <h1>{SURFACE_NAMES[surface]}</h1>
            <p className="muted small">
              {surface === "config"
                ? "Build the fields and the products the portal collects."
                : "Sign in to work on applications."}
            </p>
          </div>

          {problem && <div className="notice notice-bad">{problem}</div>}

          <div className="field">
            <label htmlFor="email">Email address</label>
            <input
              id="email" className="control" type="email" autoComplete="username"
              value={email} onChange={(event) => setEmail(event.target.value)} required autoFocus
            />
          </div>

          <div className="field">
            <label htmlFor="password">Password</label>
            <input
              id="password" className="control" type="password" autoComplete="current-password"
              value={password} onChange={(event) => setPassword(event.target.value)} required
            />
          </div>

          <button className="btn btn-primary btn-block" type="submit" disabled={busy}>
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </div>
      </form>
    </div>
  );
}
